import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-feetscare-stat';

const starSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor"
                />
              </svg>`;

const itemStat = (color, value, hasStarIcon = false) => `
        <div data-attribute="item-stat" class="item-stat">
          <div
            data-attribute="wrap-value-stat"
            class="wrap-value-stat"
            data-color-item-stat="${color}"
            style="--color-item-stat: ${color}"
          >
          <span data-attribute="value-stat" class="value-stat">${value}</span>
              <span data-attribute="icon-stat" class="icon-stat" data-show="${hasStarIcon}" data-use-svg="${hasStarIcon}">
                ${
                  hasStarIcon
                    ? `
                    ${starSvg}
              `
                    : ''
                }
              </span>
            
          </div>
          <div data-attribute="description" class="description-stat">
            <p>Said sticky, sweaty feet are gone with SOLEMIA</p>
          </div>
        </div>`;

const html = `
<div class="wrap-card container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center">Designed for everyday comfort</h2>
    <p style="text-align: center">
      Feel the weight of the day melt away as your feet embrace soothing relief and rejuvenation. Rediscover the joy of
      unwinding at home, ready to engage with your family and reclaim the peace you deserve.
    </p>
  </div>
  <div class="layout-side-by-side" data-attribute="layout-side-by-side">
    <div class="card-left" data-attribute="card-left" data-order-left="1" style="--order-left: 1">
      <div data-attribute="list-item-stat" class="list-item-stat">
        ${itemStat('#417505', '93%')}
        ${itemStat('#417505', '89%')}
        ${itemStat('#417505', '88%')}
        ${itemStat('#fbcb15', '4.9', true)}
      </div>
    </div>
    <div
      class="card-right"
      data-attribute="card-right"
      data-order-right="2"
      data-bg-color-right="#ffffff"
      style="--order-right: 2; --bg-color-right: #ffffff"
    >
      <div data-attribute="card-right-content" class="card-right-content">
        <h2>Trusted By Everyday Users</h2>
        <p>
          Long days on your feet can leave them feeling tired and uncomfortable. SOLEMIA™ Forefoot Cushion Pads provide
          soft cushioning and breathable support to help you stay comfortable throughout the day.
        </p>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#000000',
});
